import {
  timeline_default
} from "./chunk-C3SCZNET.js";
import {
  show_detail_default
} from "./chunk-BDMS7HSP.js";

// src/modules/show-detail/show-detail.tsx
import { isPast } from "date-fns";
import { jsx, jsxs } from "react/jsx-runtime";
var mShowDetail = ({
  _id,
  className = "",
  content,
  labels,
  sequence
}) => {
  const filteredTiles = content?.dateTiles?.filter((tile) => {
    return !isPast(new Date(tile?.startDate || ""));
  });
  return /* @__PURE__ */ jsxs(
    "section",
    {
      className,
      "data-module-sequence": sequence,
      "data-module-type": "mShowDetail",
      id: _id,
      children: [
        /* @__PURE__ */ jsx(
          show_detail_default,
          {
            className: "theme-light",
            cta: content?.cta,
            description: content?.description,
            endDate: content?.endDate,
            hasPerformances: filteredTiles !== void 0 && filteredTiles.length > 0,
            id: `${_id}_show_detail`,
            image: content?.image,
            labels,
            sequence,
            showId: content?.showId,
            startDate: content?.startDate,
            timelineId: `${_id}_show_timeline`,
            title: content?.name
          }
        ),
        !content?.cta && /* @__PURE__ */ jsx(
          timeline_default,
          {
            className: "theme-dark",
            dateTiles: filteredTiles,
            id: `${_id}_show_timeline`,
            labels,
            ticketsAvailable: content?.ticketsAvailable
          }
        )
      ]
    }
  );
};
var show_detail_default2 = mShowDetail;

export {
  show_detail_default2 as show_detail_default
};
